import { cn } from "@/app/common/common-functions/functions";

type ItemProps = {
  active?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const Item = ({ children, active, className, ...props }: ItemProps) => {
  return (
    <div
      className={cn(
        "tw-cursor-pointer tw-border-b-2 tw-border-transparent tw-px-3 tw-py-1 tw-font-semibold tw-text-muted-foreground",
        active && "tw-border-foreground tw-text-foreground",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

Item.displayName = "TabMenu.Item";

type TabMenuProps = React.HTMLAttributes<HTMLDivElement>;
const TabMenu = ({ children, className }: TabMenuProps) => {
  return <div className={cn("tw-flex tw-gap-3 tw-overflow-auto tw-text-nowrap tw-border-b tw-text-center", className)}>{children}</div>;
};

TabMenu.displayName = "TabMenu";

TabMenu.Item = Item;

export default TabMenu;
